import { Alert } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { classifyMomentWhen } from "../../moment-card/components/moment-card-when";
import type { FollowUpMomentDetails } from "../server/types";

export const FollowUpRecurringWarning: FC<{ details: FollowUpMomentDetails | null }> = ({
  details,
}) => {
  const { t } = useTranslation();

  const classified = classifyMomentWhen(details ?? undefined);

  if (classified.type !== "triggered") return null;

  return (
    <Alert severity="info">{t("This Follow-Up is based on a recurring communication.")}</Alert>
  );
};
